module.exports = __webpack_public_path__ + "static/media/gm.d40a97e3.svg";